$(document).ready(function() { 
    function setup_accessibility() {
        // Only remove outline when user is NOT tabbing (for accessibility)
        window.addEventListener('keydown', handle_first_tab);
        window.addEventListener('mousemove', removeTabStyle);
      }
      
      // --- helpers ---
      function handle_first_tab(e) {
        if (e.keyCode === 9) { // the "I am a keyboard user" key
          document.body.classList.add('user-is-tabbing');
          //window.removeEventListener('keydown', handle_first_tab);
        }
      }
      
      function removeTabStyle(){
        document.body.classList.remove('user-is-tabbing');
        document.body.classList.remove('tabbingOn');
      }
      
      setup_accessibility();

      $( '.workPill__slider .slider__slides' ).slick({
        slidesToShow: 3,
        variableWidth: false,
        infinite: false,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              // variableWidth: false,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              variableWidth: false,
              fade: true
            }
          },
            
        ]
      });

      $( '.workPill__products .products__list' ).slick({
        slidesToShow: 3,
        variableWidth: false,
        infinite: true,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              // variableWidth: false,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              variableWidth: false,
              fade: true
            }
          },
            
        ]
      });

      $( '.workPill__slider .slider__slides' ).on('afterChange', function(event, slick, currentSlide){
        if (slick.currentSlide >= slick.slideCount - slick.options.slidesToShow) {
          $( '.workPill__slider .slider__slides' ).slick("slickGoTo", 0);
        }
      });

      $( '.works-with .trigger' ).on( 'click', function(){
        $( this ).toggleClass( 'active' );
        $( this ).next( '.copy' ).slideToggle( 350 );
      } );

      // Works With Pillars Brand Filter - DESKTOP
      $( '.workPill__explore .explore__filters--desktop .filter' ).on( 'click', function(){
        var filterVal = $( this ).attr( 'data-id' );

        if ( $( this ).hasClass( 'active' ) )  {
          $( this ).removeClass( 'active' );
          $( '.explore__brands .brand' ).fadeOut( 200, function(){
           
            setTimeout( function(){
              $( '.explore__brands .brand' ).removeClass( 'active' ).fadeIn( 100 );
              // $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' );
            }, 200 );
          } );

        } else {
          $( '.workPill__explore .filter' ).removeClass( 'active' );
          $( this ).addClass( 'active' );
  
          $( '.explore__brands .brand' ).fadeOut( 200, function(){
           
            if ( filterVal == 'all' ) {
              setTimeout( function(){
                $( '.explore__brands .brand' ).removeClass( 'active' ).fadeIn( 100 );
                // $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' );
              }, 200 );
            } else {
              setTimeout( function(){
                $( '.explore__brands .brand' ).removeClass( 'active' );
                $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' ).fadeIn( 100 );
              }, 200 );
            }
          } );
        }     
        
      } )

      // Works With Pillars Brand Filter - MOBILE
      $( '.workPill__explore .explore__filters--mobile .chooser .filter' ).on( 'click', function(){
        $( '.explore__filters--mobile  .chooser' ).toggleClass( 'is-open' );
        $( '.explore__filters--mobile  .list' ).slideToggle( 400 );

      });

      $( '.workPill__explore .explore__filters--mobile .list .filter' ).on( 'click', function(){
        var filterVal = $( this ).attr( 'data-id' );
        $( '.explore__filters--mobile  .chooser li' ).removeClass( 'active' );
        $( '.explore__filters--mobile  .chooser' ).toggleClass( 'is-open' );
        
        
        $( '.explore__filters--mobile .chooser .filter[data-id="'+filterVal+'"]' ).closest( 'li' ).addClass( 'active' );

        $( '.explore__filters--mobile  .list' ).slideUp( 400, function(){
          setTimeout( function(){
            $( '.explore__filters--mobile  .list li' ).removeClass( 'active' );
            $( '.explore__filters--mobile .list .filter[data-id="'+filterVal+'"]' ).closest( 'li' ).addClass( 'active' );
           }, 450 );
        });

        $( '.explore__brands .brand' ).fadeOut( 200, function(){

          if ( filterVal == 'all' ) {
            setTimeout( function(){
              $( '.explore__brands .brand' ).removeClass( 'active' ).fadeIn( 100 );
              // $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' );
            }, 200 );
          } else {
            setTimeout( function(){
              $( '.explore__brands .brand' ).removeClass( 'active' );
              $( '.explore__brands .brand[data-'+filterVal+'="true"]' ).addClass( 'active' ).fadeIn( 100 );
            }, 200 );
          }
         
         
        } );

      });
});



// jQuery(document).ready(function( $ ) {

//   jQuery('#shopify-section-prodSticky').hide();  
  
//   $(window).scroll(function() {

//     var height = $('.navBar').outerHeight();
//     $('#shopify-section-prodSticky').attr('style', 'top:'+height+'px;');
   
//     if ($(document).scrollTop() > 500) {
//       $('#shopify-section-prodSticky').show();
//   }
//   else {
//       $('#shopify-section-prodSticky').hide();
//   }
//   });
// });​
